import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import {
  computed,
  toRefs, withDefaults,
} from 'vue';
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionTwoButtons',
  props: {
    align: { default: 'left' },
    labelFirstButton: { default: 'cancel' },
    colorFirstButton: { default: 'negative' },
    disabledFirstButton: { type: Boolean, default: false },
    labelSecondButton: { default: 'save' },
    colorSecondButton: { default: 'primary' },
    disabledSecondButton: { type: Boolean, default: false },
    labelDestroyButton: { default: 'destroy' },
    colorDestroyButton: { default: 'negative' },
    disabledDestroyButton: { type: Boolean, default: false },
    iconDestroyButton: {},
    hideDestroyButton: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    loadingSecondButton: { type: Boolean, default: false },
    loadingDestroy: { type: Boolean },
    titleDialogConfirm: {},
    messageDialogConfirm: {}
  },
  emits: [
  'clickFirstButton',
  'clickSecondButton',
  'clickDestroyButton',
],
  setup(__props: any, { emit: emits }) {

const props = __props;

const { t } = useI18n();



const {
  align,
  flat,
  labelFirstButton,
  disabledFirstButton,
  disabledSecondButton,
  labelSecondButton,
  colorSecondButton,
  colorFirstButton,
  loadingSecondButton,
  colorDestroyButton,
  disabledDestroyButton,
  hideDestroyButton,
  loadingDestroy,
} = toRefs(props);

const messageConfirm = computed(() => props.messageDialogConfirm || `${t('youWantRemove')}?`);
const titleConfirm = computed(() => props.titleDialogConfirm || t('removal'));


const $q = useQuasar();

function confirmDelete() {
  $q.dialog({
    title: titleConfirm.value,
    message: messageConfirm.value,
    cancel: true,
    persistent: true,
    style: { width: '75%' },
  }).onOk(() => {
    emits('clickDestroyButton');
  });
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!

  return (_openBlock(), _createBlock(_component_q_card_actions, { align: _unref(align) }, {
    default: _withCtx(() => [
      (!_unref(hideDestroyButton))
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            color: _unref(colorDestroyButton),
            disable: _unref(disabledDestroyButton),
            flat: "",
            icon: _ctx.iconDestroyButton,
            label: _ctx.labelDestroyButton,
            loading: _unref(loadingDestroy),
            onClick: confirmDelete
          }, null, 8, ["color", "disable", "icon", "label", "loading"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_space),
      _createVNode(_component_q_btn, {
        color: _unref(colorFirstButton),
        disable: _unref(disabledFirstButton),
        flat: _unref(flat),
        label: _unref(labelFirstButton),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('clickFirstButton')))
      }, null, 8, ["color", "disable", "flat", "label"]),
      _createVNode(_component_q_btn, {
        color: _unref(colorSecondButton),
        disable: _unref(disabledSecondButton),
        flat: _unref(flat),
        label: _unref(labelSecondButton),
        loading: _unref(loadingSecondButton),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('clickSecondButton')))
      }, null, 8, ["color", "disable", "flat", "label", "loading"])
    ]),
    _: 1
  }, 8, ["align"]))
}
}

})